
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.53 6.53a.75.75 0 000-1.06L19.757.697a.75.75 0 00-1.06 1.06L22.939 6l-4.242 4.243a.75.75 0 001.06 1.06L24.53 6.53zM0 6.75h24v-1.5H0v1.5z","fill":"currentColor"}})])
          )
        }
      }
    